import { render, staticRenderFns } from "./PracticeProfilePage.vue?vue&type=template&id=12b34d28"
import script from "./PracticeProfilePage.vue?vue&type=script&lang=js"
export * from "./PracticeProfilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports